import { api } from "../libs/baseApi";
import { ApiListResponse, ApiResponse } from "../types";

export interface SelectOptionsParams {
  search?: string;
  page?: number;
  limit?: number;
  [key: string]: any;
}

// Generic service for fetching select options from any endpoint
export const getSelectOptions = async <T = any>(
  endpoint: string,
  params?: SelectOptionsParams
): Promise<ApiListResponse<T[]>> => {
  try {
    const response = await api.get(`/${endpoint}`, {
      params: {
        page: params?.page,
        limit: params?.limit,
        ...params,
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching select options from ${endpoint}:`, error);
    throw error;
  }
};